import { Localization } from "@viamap/viamap2-common";
import { getPLAValueTypePostfix, isPLANumberValueType, PLAAttributeDefinition, PLAValueType } from "./PLAState";

function getPLALocale(): string | undefined {
   try {
      return Localization.getLocale();
   } catch {
      return undefined;
   }
}

export function getPLAAttributeDecimalPlaces(definition: PLAAttributeDefinition | undefined): number {
   return definition?.decimalPlaces ?? (definition?.valueType === "m2" ? 0 : 2);
}

export function formatPLANumber(value: number, decimalPlaces?: number): string {
   return new Intl.NumberFormat(getPLALocale(), decimalPlaces === undefined ? undefined : { maximumFractionDigits: decimalPlaces }).format(value);
}

export function formatPLANumberWithValueType(value: number, valueType: PLAValueType | undefined, decimalPlaces?: number): string {
   return `${formatPLANumber(value, decimalPlaces)}${getPLAValueTypePostfix(valueType)}`;
}

export function formatPLAAttributeValue(value: any, definition: PLAAttributeDefinition | undefined, fullPrecision = false): string {
   if (value === undefined || value === null || value === "") return "";
   if (isPLANumberValueType(definition?.valueType)) {
      const numericValue = typeof value === "number" ? value : Number(value);
      if (!Number.isFinite(numericValue)) return String(value);
      return fullPrecision
         ? `${numericValue}${getPLAValueTypePostfix(definition?.valueType)}`
         : formatPLANumberWithValueType(numericValue, definition?.valueType, getPLAAttributeDecimalPlaces(definition));
   }
   return String(value);
}